import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CrossTabService {
  private channel: BroadcastChannel;

  constructor() {
    // Initialize the BroadcastChannel
    this.channel = new BroadcastChannel('tab_communication');
  }

  sendMessage(action: string, data: any) {
    // Send a message to all other tabs
    this.channel.postMessage({ action, data });
  }

  onMessage(callback: (msg: any) => void) {
    // Handle incoming messages
    this.channel.onmessage = (event) => {
      callback(event.data);
    };
  }
}
